module.exports = __webpack_public_path__ + "img/16-1.594f1a45.png";